export enum VATCode {
  VAT_0 = 'VAT_00',
  VAT_01 = 'VAT_01',
  VAT_02 = 'VAT_02',
  VAT_99 = 'VAT_99'
}

export interface VatPercentage {
  vat_code: VATCode
  vat_percent: number
}

export interface VATDefinition {
  id: string
  created_timestamp: Date
  modified_timestamp: Date
  title: string
  description: string
  vat_percentages: VatPercentage[]
}

export interface FetchVatDefinitionListParams {
  count?: number
  case_sensitive?: boolean
  filter?: string
  search_text?: string
  sort_by?: string
  sort_order?: string
  start_index?: string
}

export enum VATDefinitionTabTypes {
  DETAILS = 'details'
}
